<template>
  <base-section
    id="story"
    class="white"
    space="0"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        md="6"
        class="px-10"
      >
        <base-heading
          class="font-weight-bold py-3"
          title="我们是谁?"
          align="left"
        />
        <base-body
          text="我们主要涉及孩子语言、行为、情绪、社会融合等方面的相关干预课程，使用VB-MAPP，PEAK，AFLS等相关评估工具，以应用行为分析为基础，为有需要的家庭提供相关咨询以及服务！."
          align="left"
        />
        <base-btn
          class="my-10 elevation-0 mx-1"
          rounded
          color="black"
          dark
          depressed
          href="https://store.vuetifyjs.com/products/flairo-theme-pro"
          target="_blank"
        >
          <span
            class="font-weight-black text-none"
            v-text="'Learn More'"
          />
        </base-btn>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-img
          :min-height="$vuetify.breakpoint.mdAndUp ? '500px' : '200px'"
          :height="$vuetify.breakpoint.mdAndUp ? '500px' : '200px'"
          :min-width="$vuetify.breakpoint.mdAndUp ? '600px' : '300px'"
          :src="require('@/assets/about/priscilla-du-preez-XkKCui44iM0-unsplash.jpg')"
        />
      </v-col>
    </v-row>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionStory',
  }
</script>

<style lang="scss" scoped>

</style>
